var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "help-circle",
    d: "M18,0A18,18,0,1,1,0,18,18,18,0,0,1,18,0Zm0,3.273A14.727,14.727,0,1,0,32.727,18,14.727,14.727,0,0,0,18,3.273Zm.016,21.273a1.636,1.636,0,0,1,.191,3.261L18,27.818a1.636,1.636,0,0,1-.191-3.261Zm.965-16.277a6.545,6.545,0,0,1,5.433,6.459,6.109,6.109,0,0,1-3.183,5.043,12.394,12.394,0,0,1-2.844,1.419,1.636,1.636,0,0,1-1.213-3.034l.491-.187c.092-.038.2-.082.314-.134a9.8,9.8,0,0,0,1.445-.787c1.116-.751,1.717-1.551,1.717-2.32a3.273,3.273,0,0,0-6.262-1.337l-.1.245a1.637,1.637,0,0,1-3.088-1.087,6.545,6.545,0,0,1,7.288-4.281Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.db5847bc6b09c0e955bb6ce5c9b2a08b.svg";
export { ForwardRef as ReactComponent };